<template>
  <div class="sideNav">
    <div class="sideNav_wrapper">
      <router-link tag="a"
                   v-for="(item, index) in this.activeUsers"
                   :key="index"
                   :class="['nav_item', 'nav_item_' + index]"
                   :to="item.to">
        <div class="nav_item-image">
          <img class="nav-image" alt="" :src="item.sideNav"/>
        </div>
        <div class="nav_item-name">
          <p class="nav-name" v-html="item.name"></p>
        </div>
        <div class="nav_item-button">
          <a :href="item.to" class="nav-button button-arrow">
            <img alt class="arrow-right unselectable" src="@/assets/img/homepage/arrow-right.svg"/>
          </a>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'sideNav',
  data() {
    return {
      isHover: false,
      hoverSVG: {}
    };
  },
  computed: {
    ...mapState(['userAgent', 'currentPage', 'routes']),
    activeUsers: function () {
      return this.routes.filter(function (routes) {
        return routes.active;
      });
    }
  },
  methods: {
    attachHover(index, status) {
      this.isHover = status;
      this.hoverSVG['i_' + index] = status;
      document.querySelector('.nav_item_' + index).classList.toggle('isHover');
    },
    colorAttr(index) {
      return (this.hoverSVG.hasOwnProperty('i_' + index) && this.hoverSVG['i_' + index])
          ? '#FFFFFF'
          : '#481584';
    },
    attachDivider() {
      function insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
      }

      //
      var divider = document.createElement('div');
      divider.className = 'v-divider';
      var div = document.querySelector('.nav_item_0');
      insertAfter(div, divider);
    }
  },
  mounted() {
    this.attachDivider();
  }
};
</script>

<style lang="scss">

.sideNav {
  display: flex;
  position: fixed;
  top: 90px;
  right: 50px;
  bottom: auto;
  align-items: flex-start;
  //
  border: solid 1px #c7d0dc;
  background-color: #FFFFFF;
  border-radius: 4px 0 0 4px;
  opacity: 1;
  @include media("<=tablet", "landscape") {
    right: 0;
  }
  @include media("<tablet") {
    display: none;
    opacity: 0;
  }

  .sideNav_wrapper {
    display: flex;
    flex-direction: column;
    width: 77px;

    .nav_item {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 5px 0;
      //
      cursor: pointer;
      text-decoration: none;

      &:hover {
        .nav-name {
          color: $hovered !important;
        }

        .button-arrow {
          background-color: $hovered !important;
        }
      }
    }
  }
}

.nav_item-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .nav-image {
    width: 52px;
    height: 52px;
  }
}

.nav_item-name {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5px;

  .nav-name {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #173a64;
    //
    text-transform: uppercase;
  }
}

.nav_item-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .nav-button {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
}
</style>
